import { render } from "./TktInfo.vue?vue&type=template&id=19367c68"
import script from "./TktInfo.vue?vue&type=script&lang=js"
export * from "./TktInfo.vue?vue&type=script&lang=js"

import "./TktInfo.vue?vue&type=style&index=0&id=19367c68&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__